export const LOGIN = "LOGIN"
export const CHECKTOKEN = "CHECKTOKEN"
export const LOGOUT = "LOGOUT"
export const OFFLINE = "OFFLINE"
export const ONLINE = "ONLINE"
